<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="subtitle-1"> Print Options </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-divider />
      <v-data-table
        :headers="option_headers"
        :items="optionsToDisplay"
        disable-pagination
        hide-default-footer
        mobile-breakpoint="0"
        group-by="group.name"
        :sort-by="['name']"
      >
        <template #[`group.header`]="{ items }">
          <th colspan="100%">
            {{ items[0].group.name }}
          </th>
        </template>
        <template #[`item.providerId`]="{ item }">
          {{ getProviderName(item.id) }}
        </template>
        <template #[`item.materials`]="{ item }">
          <span v-html="getMaterials(item.id)" />
        </template>
        <template #[`item.show`]="{ item }">
          <v-checkbox
            v-model="item.show"
            dense
            hide-details
            @change="updateShow(item)"
          />
        </template>
        <template #[`item.default`]="{ item }">
          <v-checkbox
            v-model="item.default"
            dense
            hide-details
            @change="updateDefault(item)"
          />
        </template>
      </v-data-table>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { uniqBy } from 'lodash';
import { mapGetters } from 'vuex';

export default {
  name: 'ProductOptions',
  data() {
    return {
      option_headers: [
        { text: 'Type', value: 'group.name' },
        { text: 'Name', value: 'display' },
        { text: 'Provider', value: 'providerId' },
        { text: 'Materials', value: 'materials' },
        { text: 'Show', value: 'show' },
        { text: 'Default', value: 'default' }
      ]
    };
  },
  computed: {
    optionsToDisplay() {
      return uniqBy(
        this.print_products.flatMap((x) => x.options).flatMap((x) => x.option),
        'id'
      ).map((x) =>
        Object.assign(x, {
          show: this.product.optionShows.includes(x.id),
          default: this.product.optionDefaults.includes(x.id)
        })
      );
    },
    print_products() {
      return this.connected(this.product.id);
    },
    materials() {
      return uniqBy(
        this.print_products.map((x) => x.material),
        'id'
      );
    },
    ...mapGetters({
      product: 'products/product',
      connected: 'print/connected',
      provider_name: 'lookup/print_provider_name'
    })
  },
  methods: {
    getProviderName(optionId) {
      const providerId = this.print_products
        .filter((x) => x.options.filter((y) => y.option.id === optionId).length)
        .map((x) => x.providerId)[0];
      return this.provider_name(providerId);
    },
    getMaterials(optionId) {
      const materials = this.print_products
        .filter((x) => x.options.filter((y) => y.option.id === optionId).length)
        .map((x) => x.material.name);
      if (materials.length === this.materials.length) {
        return 'Available for all';
      }
      return materials.join('<br>');
    },
    load() {
      this.$store.dispatch('print/getAllProducts');
    },
    updateShow(option) {
      this.saving = true;
      this.$store
        .dispatch('print/saveOptionShow', {
          coreProductId: this.product.id,
          optionId: option.id,
          value: option.show
        })
        .then(() => {
          this.$root.$snackbarSuccess('Option visibility saved');
        })
        .finally(() => {
          this.saving = false;
        });
    },
    updateDefault(option) {
      this.saving = true;
      this.$store
        .dispatch('print/saveOptionDefault', {
          coreProductId: this.product.id,
          optionId: option.id,
          value: option.default
        })
        .then(() => {
          this.$root.$snackbarSuccess('Option default saved');
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__append-outer {
  margin: 0 !important;
  margin-left: 10px !important;
  height: 40px;
}
</style>
